const normalizeSpaces = (value: string): string =>
  (value || "").trim().replace(/\s+/g, " ");

const buildUnicodeRegex = (
  pattern: string,
  flags: string,
  fallback: RegExp
): RegExp => {
  try {
    return new RegExp(pattern, flags);
  } catch {
    return fallback;
  }
};

const alphaOnlyReplaceRegex = buildUnicodeRegex(
  "[^\\p{L}\\p{M}\\s]",
  "gu",
  /[^A-Za-z\s]/g
);
const alphaWithBasicPunctuationReplaceRegex = buildUnicodeRegex(
  "[^\\p{L}\\p{M}\\s'-]",
  "gu",
  /[^A-Za-z\s'-]/g
);
const alphaNumericBasicReplaceRegex = buildUnicodeRegex(
  "[^\\p{L}\\p{M}\\p{N}\\s,.'-]",
  "gu",
  /[^A-Za-z0-9\s,.'-]/g
);
const alphaOnlyValidateRegex = buildUnicodeRegex(
  "^[\\p{L}\\p{M}\\s]+$",
  "u",
  /^[A-Za-z\s]+$/
);
const alphaWithBasicPunctuationValidateRegex = buildUnicodeRegex(
  "^[\\p{L}\\p{M}\\s'-]+$",
  "u",
  /^[A-Za-z\s'-]+$/
);

export const alphaOnly = (value: string): string =>
  normalizeSpaces(value).replace(alphaOnlyReplaceRegex, "");

export const alphaWithBasicPunctuation = (value: string): string =>
  normalizeSpaces(value).replace(alphaWithBasicPunctuationReplaceRegex, "");

export const alphaNumericBasic = (value: string): string =>
  normalizeSpaces(value).replace(alphaNumericBasicReplaceRegex, "");

export const numericOnly = (value: string): string =>
  (value || "").replace(/\D/g, "");

export const isAlphaText = (value: string): boolean =>
  alphaOnlyValidateRegex.test(normalizeSpaces(value));

export const isAlphaTextWithBasicPunctuation = (value: string): boolean =>
  alphaWithBasicPunctuationValidateRegex.test(normalizeSpaces(value));

export const isNumericText = (value: string): boolean =>
  /^\d+$/.test((value || "").trim());

export const isValidEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || "").trim());

export const validationMessages = {
  required: (label: string) => `${label} is required`,
  alphaOnly: (label: string) => `${label} must contain letters only`,
  alphaWithPunctuation: (label: string) =>
    `${label} may only include letters, spaces, apostrophes, or dashes`,
  numericOnly: (label: string) => `${label} must contain only numbers`,
  emailInvalid: "Please enter a valid email address",
  phoneRequired: "Phone number is required",
  phoneLength: (expected: number) =>
    `Phone number must be ${expected} digits for the selected country`,
  phoneInvalid: "Please enter a valid phone number",
} as const;
